<template>
  <div class="table-row pinned-tab">
    <!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
    <div class="report-side-panel">
      <div class="sub-header">
        <!--- <report-header></report-header>-->
        <div class="date-range">
          <!--<VueDatePicker v-model="year" :min-date="min_date" :max-date="max_date" type="year" />-->
          
          <div class="download-button-wrapper">
            <a
              data-v-200367fa
              href
              class="cta-btn release-btn"
              @click.prevent="exportEmployeesDataExcel()"
            >Download</a>
          </div>
          <!-- <i class="csv-export button-export" @click.stop="exportExcel()"></i> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import _ from "lodash";
import moment from "moment";
export default {
  name: "ExportEmployeeData",
  data: () => {
    return {
      error: false,
      masterTableWidth: 0,
      loadMore: true,
      timeout: 0
    };
  },
 
  computed: {
    
  },
  beforeMount() {
    //this.fetchUpdatedReport();
  },
  methods: {
    exportEmployeesDataExcel: function() {
       this.$store.dispatch("exportEmployees");
    }
  },
  updated() {},
  mounted() {},

  destroyed() {},
  watch: {}
};
</script>
<style scoped>
.error-border {
  border: 1px solid red;
}

.table-row {
  padding: 20px 20px 10px 20px;
  background: none;
  border: 1px solid rgba(192, 192, 192, 0.3411764705882353);
  border-radius: 11px;
}

.qtime-activity-view {
  width: 100%;
}

.table-row .position {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 10px;
}

.month-year-label {
  margin-bottom: 10px;
}

.download-button-wrapper {
  width: 100%;
  text-align: center;
}

.cta-btn {
  padding: 7px 19px;
  margin: 0 auto;
}


.sub-header .date-range,
.sub-header{
  border-top: none !important;
  border-bottom: none !important;
}

.table-row{
  height: 83px;
}



@media screen and (max-width: 1573px){
  .sub-header .date-range{
      padding-left: 0;
      }
}
</style>